import { render, staticRenderFns } from "./ShouninRireki.vue?vue&type=template&id=90772742&scoped=true&"
import script from "./ShouninRireki.vue?vue&type=script&lang=ts&"
export * from "./ShouninRireki.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninRireki.vue?vue&type=style&index=0&id=90772742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90772742",
  null
  
)

export default component.exports